import http from "./HttpService";

const BASE_SERVICE_URL = "estore-service";

export default {
  getStoreDetails(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL +
            "/v1/public/customer/estore/settings/store/details",
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getOrders(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v2/customer/estore/order",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getOrderDetails(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v4/customer/estore/order/transaction/details/${request.tracking_uuid}`,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getPublicOrderDetails(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v2/public/estore/tracking/${request.tracking_uuid}`,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  viewCart(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v2/public/estore/checkout/${request.checkout_uuid}`,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  uploadCustomerDepositSlip(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v2/customer/estore/order/deposit_slip",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  checkout(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v7/customer/estore/cart/checkout`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  publicCheckout(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v2/public/estore/checkout/${request.checkout_uuid}`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  verifyVoucher(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v1/customer/estore/cart/voucher/verify",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  applyVoucher(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v1/customer/estore/cart/voucher/save",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  removeVoucher(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL + "/v1/customer/estore/cart/voucher/remove",
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  updateDelivery(request) {
    return new Promise((resolve, reject) => {
      http
        .put(
          `${BASE_SERVICE_URL}/v2/public/estore/checkout/${request.checkout_uuid}/update-delivery-type`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  addBilling(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/address/billing/add`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  paynamics(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `payments-service/transact/paynamics`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  gcashPaynamics(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `payments-service/transact/paynamics/gcash`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getWebDesign(request) {
    return new Promise((resolve, reject) => {
      http
        .get("design-service/customer/web/get-design", request.header)
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  checkPaymentStatus(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          "payments-service/transact/paynamics/response",
          request.order_id,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  checkBranches(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `estore-service/v3/customer/estore/cart/check/location`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  followUpOrder(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v1/customer/estore/order/send/follow_up/${request.uuid}`,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  cancelOrder(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/order/cancel`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  // MEDPadala
  medPadalaBalanceInquiry(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v2/customer/estore/cart/med-padala/balance-inquiry`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  medPadalaSaveAmount(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/cart/med-padala/save`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  medPadalaRemove(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/cart/med-padala/remove`,
          null,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  payViaPayMongo({ payload, header }) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/payment/paymongo/add${
            payload.type === "gcash" || payload.type === "grab_pay"
              ? "/source"
              : ""
          }`,
          payload,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  getPayMongoPaymentIntent({ id, header }) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `payments-service/v1/customer/paymongo/payment/intents/${id}`,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  deletePayMongoPaymentMethod({ transactionNumber, header }) {
    return new Promise((resolve, reject) => {
      http
        .delete(
          `payments-service/v1/customer/paymongo/payment/methods/${transactionNumber}`,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  updateLocation(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v2/public/estore/checkout/${request.checkout_uuid}/update-location`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
};
